<template>
  <div class="animated fadeIn">
    <customer-location-card
      v-if="customer_location"
      :customer_location="customer_location"
      :is_form="true"
    />
    <b-form @submit.prevent="onSubmit">
      <b-card no-body>
        <b-card-header>
          <span class="text-muted text-uppercase">{{
            form_label
              ? form_label
              : customer_location
              ? `Update ${customer_location.street_address}`
              : "New Location"
          }}</span>
        </b-card-header>
        <div class="py-3 px-5">
          <b-form-group label="Street Address" :label-cols="3">
            <b-form-input
              v-model="form_data.street_address"
              :state="!$v.form_data.street_address.$invalid"
              invalid-feedback="Required"
              placeholder="Street Address"
              type="text"
            />
          </b-form-group>
          <b-form-group
            :label-cols="3"
            :state="!$v.form_data.country.$invalid"
            invalid-feedback="Required"
            label="Country"
          >
            <multiselect
              v-model="form_data.country"
              :options="country_options"
              :multiple="false"
            />
          </b-form-group>
          <b-form-group
            :label-cols="3"
            :state="!$v.form_data.region.$invalid"
            invalid-feedback="Required"
            label="Province/State"
          >
            <multiselect
              v-model="form_data.region"
              :disabled="!form_data.country"
              :options="region_options"
              :multiple="false"
            />
          </b-form-group>
          <b-form-group label="City" :label-cols="3">
            <b-form-input
              v-model="form_data.city"
              :state="!$v.form_data.city.$invalid"
              invalid-feedback="Required"
              placeholder="City"
              type="text"
            />
          </b-form-group>
          <b-form-group label="Postal/Zip Code" :label-cols="3">
            <b-form-input
              v-model="form_data.postal_code"
              :state="!$v.form_data.postal_code.$invalid"
              invalid-feedback="Required"
              placeholder="Postal/Zip Code"
              type="text"
            />
          </b-form-group>
          <b-form-group
            :label-cols="3"
            :state="!$v.form_data.type.$invalid"
            invalid-feedback="Required"
            label="Type (i.e. Shipping/Billing)"
          >
            <b-form-select
              v-model="form_data.type"
              :options="location_type_options"
            />
          </b-form-group>
        </div>
      </b-card>
      <b-row v-if="!is_customer_form" class="mb-3" align-h="end">
        <b-col lg="2" md="4" sm="12">
          <b-button
            :disabled="isInvalid"
            @click="submitForm"
            block
            variant="success"
            ><i class="fal fa-address-book" /> Save</b-button
          >
        </b-col>
      </b-row>
    </b-form>
  </div>
</template>

<script>
import CustomerLocationCard from "@/components/crm/customerlocation/CustomerLocationCard";
import Multiselect from "vue-multiselect";
import raw_country_data from "@/shared/_countries";
import { validationMixin } from "vuelidate/src";
import { required } from "vuelidate/lib/validators";

const country_data = raw_country_data
  .map((i) => [i.countryName, i.regions.map((j) => j.name)])
  .reduce((r, i) => {
    r[i[0]] = i[1];
    return r;
  }, {});

export default {
  name: "CustomerLocationForm",
  mixins: [validationMixin],
  components: {
    CustomerLocationCard,
    Multiselect,
  },
  props: {
    customer_location: {
      type: Object,
      default: () => null,
    },
    form_label: {
      type: String,
      default: null,
    },
    is_customer_form: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      form_data: {
        street_address: null,
        city: null,
        region: null,
        country: "Canada",
        postal_code: null,
        type: "Shipping/Billing",
      },
      location_type_options: [
        { text: "No Type Selected", value: null },
        "Shipping",
        "Billing",
        "Shipping/Billing",
      ],
    };
  },
  computed: {
    country_options() {
      return Object.keys(country_data);
    },
    isInvalid() {
      return this.$v.$invalid;
    },
    region_options() {
      return this.form_data.country && country_data[this.form_data.country]
        ? country_data[this.form_data.country]
        : [];
    },
  },
  validations: {
    form_data: {
      street_address: { required },
      city: { required },
      region: { required },
      country: { required },
      postal_code: { required },
      type: { required },
    },
  },
  methods: {
    submitForm() {
      this.$emit("submit", this.form_data);
    },
  },
  watch: {
    form_data: {
      handler() {
        this.is_customer_form &&
          this.$emit(
            "updateFormData",
            "customer_location",
            this.form_data,
            !this.isInvalid
          );
      },
      deep: true,
      immediate: true,
    },
  },
  created() {
    this.customer_location &&
      (this.form_data = {
        ...this.customer_location.cloneAttributes(true, true, [
          "id",
          "customer_id",
        ]),
      });
  },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
